<template>
  <div class="d-flex flex-column">
    <subnav :links="subnav" heading="Рецептуры и продукты"/>
    <transition name="fade" mode="out-in">
      <router-view/>
    </transition>
  </div>
</template>

<script>
  export default {
    data: () => ({
      subnav: [
        {
          text: 'Продукты',
          to: '/settings/recipes/products',
        },
        {
          text: 'Ингредиенты',
          to: '/settings/recipes/ingredients',
        },
      ],
    }),
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/settings/recipes.vue